module.exports = __webpack_public_path__ + "static/media/Tender_Extension1.329887d8.pdf";